// Keys used in the single pet view's ?tab= search param
export const PET_TAB_OVERVIEW = "overview";
export const PET_TAB_THERAPIES = "therapies";
export const PET_TAB_GRAPHS = "graphs";
export const PET_TAB_CHARTS = "charts";
export const PET_TAB_APPOINTMENTS = "appointments";
export const PET_TAB_DOCUMENTS = "documents";
export const PET_TAB_BIOMETRICS = "biometrics";
export const PET_TAB_NOTES = "notes";
export const PET_TAB_SETTINGS = "settings";
